module.exports = __webpack_public_path__ + "img/robby-bubble-logo.0c8ce46.png";